"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredError = exports.COLLECTION_FORMATS = exports.BaseAPI = exports.BASE_PATH = void 0;
var _axios = _interopRequireDefault(require("axios"));
const BASE_PATH = exports.BASE_PATH = "https://auth.web.auto".replace(/\/+$/, "");
const COLLECTION_FORMATS = exports.COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|"
};
class BaseAPI {
  constructor(configuration, basePath = BASE_PATH, axios = _axios.default) {
    this.basePath = basePath;
    this.axios = axios;
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}
exports.BaseAPI = BaseAPI;
;
class RequiredError extends Error {
  name = "RequiredError";
  constructor(field, msg) {
    super(msg);
    this.field = field;
  }
}
exports.RequiredError = RequiredError;
//# sourceMappingURL=base.js.map